const CONSTANT_0 = 0
const CONSTANT_1 = 1
const CONSTANT_2 = 2
const CONSTANT_3 = 3
const CONSTANT_4 = 4
const CONSTANT_5 = 5

export const datePickerOption = {
  firstDayOfWeek: 1,
  shortcuts: [
    {
      text: "今日",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "昨日",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近一年",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
        picker.$emit("pick", [start, end]);
      },
    },
  ],
}

export const modelOptionalsKeyMap = new Map([
  ['optional1', '选装1（座位）'],
  ['optional2', '选装2'],
  ['optional3', '选装3'],
  ['optional4', '选装4'],
  ['optional5', '选装5'],
  ['optional6', '选装6'],
  ['optional7', '选装7'],
  ['optional8', '选装8'],
  ['optional9', '选装9'],
])

// 盲订订单退订状态 0未申请 1已申请 2退款成功 3退款拒绝
export const refundStatusMap = new Map([
  [CONSTANT_0, '未申请'],
  [CONSTANT_1, '申请中'],
  [CONSTANT_2, '退款成功'],
  [CONSTANT_3, '退款拒绝'],
])

// 盲订订单状态 0未转订单 1已转订单 2已取消 3已退订 4已成交
export const blindOrderStatusMap = new Map([
  [CONSTANT_0, '未转订单'],
  [CONSTANT_1, '已转订单'],
  [CONSTANT_4, '已成交'],
  [CONSTANT_2, '已取消'],
  [CONSTANT_3, '已退订'],
])

// 小订订单状态 0已支付 1交易成功 2交易关闭
export const smallOrderStatusMap = new Map([
  [CONSTANT_0, '已支付'],
  [CONSTANT_1, '交易成功'],
  [CONSTANT_2, '交易关闭'],
])

// 小订订单进度
export const smallOrderStepListMap = new Map([
  [CONSTANT_0, { list: ["已支付", "交易成功", "交易关闭"], step: 0 }],
  [CONSTANT_1, { list: ["已支付", "交易成功", "交易关闭"], step: 1 }],
  [CONSTANT_2, { list: ["已支付", "交易成功", "交易关闭"], step: 2 }],
])

// 未转大订  ["未转大订", "已转大订", "已成交"]
// 已转大订  ["未转大订", "已转大订", "已成交"]
// 已成交  ["未转大订", "已转大订", "已成交"]
// 已取消  ["未转大订", "已取消"]
// 已退订  ["未转大订", "已转大订", "已退订"]

// 盲订订单进度
export const stepListMap = new Map([
  [CONSTANT_0, { list: ["未转大订", "已转大订", "已成交"], step: 0 }],
  [CONSTANT_1, { list: ["未转大订", "已转大订", "已成交"], step: 1 }],
  [CONSTANT_4, { list: ["未转大订", "已转大订", "已成交"], step: 2 }],
  [CONSTANT_2, { list: ["未转大订", "已取消"], step: 2 }],
  [CONSTANT_3, { list: ["未转大订", "已转大订", "已退订"], step: 3 }],
])

//小订退款状态, 0: 未申请 1: 退款中 2: 退款成功 3: 退款失败
export const smallOrderRefundStatusMap = new Map([
  [CONSTANT_0, '未申请'],
  [CONSTANT_1, '退款中'],
  [CONSTANT_2, '退款成功'],
  [CONSTANT_3, '退款失败'],
])

// 操作记录标题枚举
export const orderStatusDics = [
  { orderStatus: 1, name: "待提交" },
  { orderStatus: 2, name: "已提交" },
  { orderStatus: 3, name: "经理已审核" },
  { orderStatus: 4, name: "已配车" },
  { orderStatus: 5, name: "配车已审核" },
  { orderStatus: 6, name: "订单已驳回" },
  { orderStatus: 7, name: "配车已驳回" },
  { orderStatus: 8, name: "取消订单" },
  { orderStatus: 9, name: "修改订单" },
  { orderStatus: 10, name: "已交车" },
  { orderStatus: 11, name: "订单已撤回" },
  { orderStatus: 12, name: "授权配车" },
  { orderStatus: 13, name: '订单已退订' },
  { orderStatus: 14, name: '申请退款' },
  { orderStatus: 15, name: '撤销退款' },
  { orderStatus: 16, name: '退款审核中' },
  { orderStatus: 17, name: '退款审核通过' },
  { orderStatus: 18, name: '待退款' },
  { orderStatus: 19, name: '已锁单' }
]